<!-- 骑士优惠券 -->
<template>
    <vant-popup
        class="section-detail-coupon"
        v-model="show"
        position="bottom"
        :close-on-click-overlay="false"
        @click-overlay="close"
    >
        <h2 class="title">优惠券</h2>
        <i class="close" @click="close"></i>
        <div class="scroll-list">
            <!-- <scroll
                @resend="scrolltoend"
                @scrolltoend="scrolltoend"
                :loadText="loadText"
                class="tab-container"
                container="cur-child"
            >-->
            <scroll
                @resend="scrolltoend"
                @scrolltoend="scrolltoend"
                :loadText="''"
                class="tab-container"
                container="cur-child"
            >
                <div class="detail-coupon-list" v-if="canReceiveCouponList.length">
                    <!-- <p class="sub-title">可领取优惠券</p> -->
                    <!-- <coupon-list
                        :coupons="canReceiveCouponList"
                        @onreceive="onReceive"
                        @gotouse="gotoUse"
                        :showGotoUseBtn="false"
                    ></coupon-list>-->
                    <coupon-list
                        :useNewVersion="useNewVersion"
                        :coupons="canReceiveCouponList"
                        :customGotoUse="true"
                        @onreceive="onReceive"
                        @gotouse="gotoUse"
                    ></coupon-list>
                </div>
                <!-- <div class="detail-coupon-list used" v-if="receiveCouponList.length">
                    <p class="sub-title">已领取优惠券</p>
                    <coupon-list
                        :customGotoUse="true"
                        :coupons="receiveCouponList"
                        @onreceive="onReceive"
                        :showReceiveIcon="false"
                        @gotouse="gotoUse"
                    ></coupon-list>
                </div>-->
            </scroll>
        </div>
    </vant-popup>
</template>
<script>
import VantPopup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Scroll from '@components/scroll/scroll';
import CouponList from 'root/common/components/coupon/couponList.vue';
export default {
    name: 'detail-coupon',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        receiveCouponList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        canReceiveCouponList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        loadText: {
            type: String,
            default: '',
        },
        useNewVersion: {
            default: false,
            type: Boolean,
        },
    },
    components: {
        VantPopup,
        CouponList,
        Scroll,
    },
    data() {
        return {};
    },
    mounted() {},
    updated() {},
    methods: {
        open() {
            this.$emit('update:visible', false);
        },
        close() {
            this.$emit('close');
        },
        onReceive(res, item, index) {
            this.$emit('onreceive', res, item, index);
        },
        gotoUse(item, index) {
            this.$emit('gotouse', item, index);
        },
        scrolltoend() {
            this.$emit('scrolltoend');
        },
    },
};
</script>
<style lang="scss" scoped>
.section-detail-coupon {
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    background: #fff;
    .close {
        width: 0.4rem;
        height: 0.4rem;
        background: url('~root/blackcard/assets/image/detail/icon-close.png') no-repeat center;
        background-size: 0.28rem 0.28rem;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
    }
    .title {
        line-height: 1rem;
        font-size: 0.28rem;
        color: #333;
        font-weight: bold;
        text-align: center;
        position: relative;
        &:after {
            content: ' ';
            position: absolute;
            pointer-events: none;
            box-sizing: border-box;
            top: -50%;
            left: -50%;
            right: -50%;
            bottom: -50%;
            -webkit-transform: scale(0.5);
            transform: scale(0.5);
            border: 0 solid #e5e5e5;
            border-bottom-width: 1px;
        }
    }
    .sub-title {
        font-size: 0.24rem;
        color: #999;
        padding: 0 0.2rem 0.2rem;
    }
    .detail-coupon-list {
        padding: 0.2rem 0 0;
        &.used {
            padding: 0.13rem 0 0;
        }
    }
    .scroll-list {
        height: 71vh;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        &:after {
            width: 100%;
            height: 0.68rem;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
        }
    }
}
</style>
<style lang="scss">
.mint-toast {
    z-index: 9999;
}
.section-detail-coupon {
    .mint-loadmore-bottom {
        background: #fff;
    }
}
</style>
